export default __webpack_public_path__ + "static/media/i7.ee2b5a0b.png";